<script setup lang="ts">
const props = defineProps<{
    height: TTailwindHeight,
    gap: TTailwindGap,
    pr: Extract<TTailwindPadding, `pr-${ number }`>,
    duration: `${ number }s`,
}>();
</script>

<template>
    <div 
        class="overflow-hidden"
        :class="props.height"
    >
        <div class="auto-scroll w-max h-full flex items-center">
            <div 
                class="flex items-center shrink-0"
                :class="[props.gap, props.pr]"
            >
                <slot />
            </div>
            <div
                class="flex items-center shrink-0"
                :class="[props.gap, props.pr]"
            >
                <slot />
            </div>
        </div>
    </div>
</template>

<style scoped>
.auto-scroll {
    animation: animation v-bind('props.duration') infinite linear;
}
@keyframes animation {
  to { transform: translateX(50%); }
}
</style>